import cn from 'classnames/bind';

import s from './WithTornBackground.module.scss';

const cx = cn.bind(s);

const WithTornBackground = ({
  children, prepend, className, skipContentOffset = false, ...attrs
}) => (
  <div className={cx(className, 'wrapper')} {...attrs}>
    { prepend }
    <div className={cx('content', {
      noGutter: skipContentOffset,
    })}>
      { children }
    </div>
    <div className={cx('background')}>
      <img src={'/images/tornBackground.svg'} alt="" />
    </div>
  </div>
);

export default WithTornBackground;
